import React from 'react';
import { LuPhoneCall } from 'react-icons/lu';
import { FaWhatsapp } from 'react-icons/fa';

const FloatingActionButtons = ({
  phoneNumber = '8101463629', // your number without country code
  countryCode = '+91',
  whatsappMessage = 'Hello Mern Digital! I would like to know more about your services.'
}) => {
  const encodedMessage = encodeURIComponent(whatsappMessage);
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${countryCode}${phoneNumber}&text=${encodedMessage}`;
  const callUrl = `tel:${countryCode}${phoneNumber}`;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-center gap-4">
      {/* WhatsApp Floating Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-green-500 text-white shadow-lg transition-transform duration-300 ease-in-out hover:bg-green-600 hover:scale-110"
      >
        <FaWhatsapp className="h-8 w-8" />
      </a>

      {/* Call Floating Button */}
      <a
        href={callUrl}
        aria-label="Call us"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-blue-500 text-white shadow-lg transition-transform duration-300 ease-in-out hover:bg-blue-600 hover:scale-110"
      >
        <LuPhoneCall className="h-6 w-6" />
      </a>
    </div>
  );
};

export default function App() {
  return (
    <div className="relative">
      <FloatingActionButtons phoneNumber="8101463629" />
    </div>
  );
}

//